import { render } from "./CarAllowance.vue?vue&type=template&id=0c37082f&scoped=true"
import script from "./CarAllowance.vue?vue&type=script&lang=js"
export * from "./CarAllowance.vue?vue&type=script&lang=js"

import "./CarAllowance.vue?vue&type=style&index=0&id=0c37082f&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c37082f"]])

export default __exports__